import React, { useEffect, useRef } from 'react';
import {Chart} from 'chart.js'; // Chart.js v2

const ChartJSv2Wrapper = ({ type, data, options }) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const ctx = canvasRef.current.getContext('2d');

    // Destroy previous chart instance if it exists
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
      chartInstanceRef.current = null;
    }

    // Create new chart instance
    chartInstanceRef.current = new Chart(ctx, {
      type,
      data,
      options,
    });

    // Cleanup on unmount
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [type, data, options]);

  return <canvas ref={canvasRef} />;
};

export default ChartJSv2Wrapper;
